var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h' + _vm.size,{tag:"component",staticClass:"tw-font-medium",class:_vm.headingClasses},[_vm._v("\n"+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }